export default __webpack_public_path__ + "static/media/logo_commu_agglo_henin_carvin.dc8ce4e5.png";